import React from "react";
import { connect } from "react-redux";
import { callPinUpdate, callPinValidation } from "../../../actions/cardControls.actions";
import CardControlsComplete from "../misc/card-controls-complete.component";
import { ReplaceCardOptionsForm } from "../forms/replace-card-options-form.component";
import { TravelExemptionMfaForm } from "../forms/auth-travel-exemption-mfa-form.component";
import VerifyMailingAddress from "../misc/verify-mailing-address.component";  

const ReplaceCardFlowComponent = (props) => {
  switch (props.processStep) {
    case 1:
      return <ReplaceCardOptionsForm {...props} advanceToNextStep={() => props.setProcessStep(2)} />;
    case 2:
      return <TravelExemptionMfaForm
        backToLoans={props.backToCards}
        advanceToNextStep={() => props.setProcessStep(3)}
        buttonText ="Back to Cards"
      />;
    case 3:
      return <VerifyMailingAddress {...props} advanceToNextStep={() => props.setProcessStep(4)} />;
    case 4:
      return <CardControlsComplete {...props} />;
    default:
      return <div>Something has gone wrong.</div>;
  }
};

const mapDispatchToProps = {
  callPinUpdate,
  callPinValidation
};
const ReplaceCardFlow = connect(null, mapDispatchToProps)(ReplaceCardFlowComponent);

export default ReplaceCardFlow;



// WEBPACK FOOTER //
// ./src/components/card-controls/flow-components/replace-card-flow.component.js